import React from 'react';

/**
 * ZitoFooter — global footer for zitotrontech.com.
 */

const ZitoFooter: React.FC = () => {
  return (
    <footer style={{
      marginTop: 60,
      padding: '32px 20px 28px',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      background: 'rgba(8, 8, 14, 0.6)',
      color: '#9a9ab0',
      fontSize: 13,
      lineHeight: 1.55,
      textAlign: 'center',
    }}>
      <div style={{ maxWidth: 980, margin: '0 auto' }}>
        {/* Brand line */}
        <div style={{
          fontSize: 14, color: '#cfcfdc', fontWeight: 700,
          marginBottom: 4, letterSpacing: 0.2,
        }}>
          Zitotron Tech LLC
        </div>

        {/* Address + copyright */}
        <div style={{ color: '#9a9ab0', fontSize: 12, marginBottom: 16 }}>
          Portland, Oregon, USA 🇺🇸
          <br />
          © 2026 Zitotron Tech LLC · All Rights Reserved
        </div>

        {/* Minimal footer link row. */}
        <div style={{
          fontSize: 12, color: '#9a9ab0',
          display: 'flex', flexWrap: 'wrap', justifyContent: 'center',
          gap: '6px 14px',
        }}>
          <a href="https://zitotrontech.com" style={linkStyle}>zitotrontech.com</a>
        </div>
      </div>
    </footer>
  );
};

const linkStyle: React.CSSProperties = {
  color: '#cfcfdc', textDecoration: 'none', fontWeight: 600,
};

export default ZitoFooter;
